<template>
  <div class="rooms__content">
    <div class="rooms">
      <div v-for="branch in branches" :key="branch.id" class="rooms__branch">
        <div class="rooms__branch__header">
          <vs-icon icon="home"></vs-icon>
          <h3>
            <span>{{ branch.name || 'Unknown branch' }}</span>
          </h3>
          <vs-button color="primary" type="flat" @click="addRoom(branch.id)"
            >+ Add Room</vs-button
          >
        </div>
        <vs-list>
          <vs-list-item
            v-for="room in branch.rooms"
            :key="room.id"
            :icon="room.icon"
            :title="room.name"
            :subtitle="`${room.is_saturday || room.is_sunday ? '+' : ''} ${
              room.is_saturday ? 'Saturday' : ''
            } ${room.is_saturday && room.is_sunday ? '|' : ''} ${
              room.is_sunday ? 'Sunday' : ''
            }`"
          >
          <vs-button
              :data-id="room.id"
              :data-branch-id="branch.id"
              radius
              color="dark"
              icon="edit"
              type="flat"
              @click="editRoom"
            ></vs-button>
            <vs-button
              :data-id="room.id"
              :data-branch-id="branch.id"
              radius
              color="dark"
              icon="delete"
              type="flat"
              @click="deleteRoom"
            ></vs-button>
          </vs-list-item>
        </vs-list>
      </div>
    </div>

    <div class="rooms__form">
      <vs-popup
        @close="closePopupHandle"
        classContent="rooms__popup"
        :title="`${selectedRoom.id ? 'Edit' : 'Add'} room in ${
          selectedBranch.name || 'Unknown branch'
        }`"
        :active.sync="popupActive"
      >
        <RoomForm
          v-if="popupActive"
          :room="selectedRoom"
          :branch="selectedBranch"
          @closePopup="closePopup"
        />
      </vs-popup>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import RoomForm from '@/components/settings/roomForm'

export default {
  name: 'Rooms',
  data() {
    return {
      selectedRoom: {},
      popupActive: false,
      selectedBranch: {},
    }
  },
  components: { RoomForm },
  computed: {
    ...mapState({
      rooms: (state) => state.rooms.rooms,
      branches: (state) => state.branches.branches,
    }),
  },
  methods: {
    addRoom: function (branchId) {
      this.selectedBranch = this.branches.find((b) => b.id == branchId)
      this.popupActive = true
    },
    editRoom: function (e) {
      this.selectedRoom = this.rooms.find(
        (r) => r.id == e.target.parentElement.dataset.id
      )
      this.selectedBranch = this.branches.find(
        (b) => b.id == e.target.parentElement.dataset.branchId
      )
      this.popupActive = true
    },
    deleteRoom: function (e) {
      this.selectedRoom = this.rooms.find(
        (r) => r.id == e.target.parentElement.dataset.id
      )
      this.$store
        .dispatch('rooms/deleteRoomAction', {
          room: {
            id: this.selectedRoom.id,
          },
        })
        .then(() => {
          this.$vs.notify({
            title: 'Removed',
            text: `Room ${this.selectedRoom.name} removed`,
            color: 'success',
            position: 'top-right',
          })
          this.$store.dispatch('branches/getBranchesAction')
          this.selectedRoom = {}
        })
        .catch((r) => {
          this.$vs.notify({
            title: 'Remove Error',
            text: r.message,
            color: 'danger',
            position: 'top-right',
          })
          this.selectedRoom = {}
        })
      this.popupActive = false
    },
    closePopup: function () {
      this.popupActive = false
      this.selectedRoom = {}
    },
    closePopupHandle: function () {
      this.selectedRoom = {}
    },
  },
}
</script>
<style lang="scss">
.rooms__content {
  width: 70%;
}
.rooms {
  display: flex;
  flex-flow: row wrap;
  gap: 50px;
}
.rooms__branch {
  margin-bottom: 20px;
  width: 40%;
  &__header {
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    gap: 10px;
  }
}
</style>
